<template>
  <div class="d-flex flex-column ga-2 ga-md-4">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <StatisticsCard
          :title="$t('labels.statistics.new-contacts.title')"
          :statistic="statistics && String(statistics.totalLeadCountByStatus?.new)"
          :sub-statistic="statistics && String(statistics.totalLeadCountByStatus?.newWithValuation)"
          :sub-title="$t('labels.statistics.new-contacts.subtitle')"
          icon="mdi-account-plus-outline"
          icon-color="white"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <StatisticsCard
          :title="$t('labels.statistics.all-contacts.title')"
          :statistic="statistics && String(statistics?.totalLeadCount.total)"
          :sub-statistic="statistics && String(statistics?.totalLeadCount.withValuation)"
          :sub-title="$t('labels.statistics.all-contacts.subtitle')"
          icon="mdi-account-group-outline"
          icon-color="white"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <StatisticsCard
          :title="$t('labels.statistics.real-estate-volume.title')"
          :statistic="statistics && formatPrice(statistics?.totalLeadValue)"
          :sub-statistic="statistics && String(statistics?.totalValuationCount)"
          :sub-title="$t('labels.statistics.real-estate-volume.subtitle')"
          icon="mdi-home-analytics"
          icon-color="white"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <StatisticsCard
          v-if="
            statistics?.totalCommissionValue.commission &&
            statistics?.totalCommissionValue.commission != '0'
          "
          :title="$t('labels.statistics.provision.title')"
          :statistic="statistics && formatPrice(statistics?.totalCommissionValue.value)"
          :sub-statistic="statistics && String(statistics?.totalCommissionValue.commission) + '%'"
          :sub-title="$t('labels.statistics.provision.subtitle')"
          icon="mdi-sack-percent"
          icon-color="white"
        />
        <StatisticsCard
          v-else
          :title="$t('labels.statistics.potential-provision.title')"
          statistic="0"
          sub-statistic="0"
          :sub-title="$t('labels.statistics.potential-provision.title')"
          icon="mdi-sack-percent"
          icon-color="white"
        />
      </v-col>
    </v-row>

    <v-card
      border
      class="pa-5 no-focus"
      @click="showInteractionDetails = !showInteractionDetails"
    >
      <div class="d-flex align-center">
        <div>
          <v-icon
            class="static-gradient-background rounded-circle pa-7"
            color="white"
            size="x-large"
            style="font-size: 40px"
          >
            mdi-gesture-double-tap
          </v-icon>
        </div>

        <div class="pb-0 text-h5 font-weight-medium d-flex w-full">
          <div class="d-flex flex-column px-4">
            <span class="text-h6 text-grey font-weight-light">{{
              $t('labels.statistics.interactions')
            }}</span>
            <div class="pb-0 font-weight-medium">
              <v-progress-circular
                v-if="!statistics"
                indeterminate
              />
              <span v-else>{{
                directTrafficCount +
                facebookTrafficCount +
                googleTrafficCount +
                qrCodeTrafficCount +
                customTrafficCount
              }}</span>
            </div>
          </div>

          <v-spacer />

          <div
            v-if="$vuetify.display.mdAndUp"
            class="d-flex align-center"
          >
            <InteractionStatistics
              :direct-traffic-count="directTrafficCount"
              :qr-code-traffic-count="qrCodeTrafficCount"
              :facebook-traffic-count="facebookTrafficCount"
              :google-traffic-count="googleTrafficCount"
            />
          </div>

          <v-spacer />
          <v-btn
            v-if="customTrafficCount > 0"
            icon
            color="black"
            variant="text"
            size="small"
            width="28"
            height="28"
            style="font-size: 16px"
          >
            <v-icon color="primary">
              {{
                showInteractionDetails
                  ? 'mdi-chevron-up-circle-outline'
                  : 'mdi-chevron-down-circle-outline'
              }}
            </v-icon>
          </v-btn>
        </div>
      </div>

      <div
        v-if="$vuetify.display.smAndDown"
        class="d-flex"
      >
        <InteractionStatistics
          :direct-traffic-count="directTrafficCount"
          :qr-code-traffic-count="qrCodeTrafficCount"
          :facebook-traffic-count="facebookTrafficCount"
          :google-traffic-count="googleTrafficCount"
        />
      </div>

      <v-expand-transition v-if="customTrafficCount > 0">
        <div
          v-show="showInteractionDetails"
          class="mt-5"
        >
          <v-divider />

          <div class="mt-4 text-h6 text-grey font-weight-light">
            {{ $t('statistics.custom') }}
          </div>
          <span class="text-body-2 text-grey font-weight-light">{{
            $t('statistics.custom-info')
          }}</span>

          <v-card-text class="px-0 pb-0 mx-0 mb-0 mt-2">
            <div class="d-flex">
              <v-row>
                <v-col
                  v-for="(count, name) of customTraffic"
                  :key="name"
                  sm="3"
                  class="py-0 text-center text-grey text-sm-left"
                >
                  <span class="mr-1 text-subtitle-1 font-weight-bold text-grey text--darken-3">{{
                    count
                  }}</span>
                  <br class="d-block d-sm-none" />
                  {{ name }}
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import currencyMixin from '@/mixins/currency'

import InteractionStatistics from './InteractionStatistics.vue'
import STATISTICS from './Statistics.gql'
import StatisticsCard from './StatisticsCard.vue'

export default {
  components: {
    StatisticsCard,
    InteractionStatistics,
  },
  mixins: [currencyMixin],
  data() {
    return {
      showInteractionDetails: false,
    }
  },
  apollo: {
    statistics: {
      query: STATISTICS,
      variables() {
        return {
          input: {
            companyId: this.$auth.user.companyId,
          },
        }
      },
    },
  },
  computed: {
    customTraffic() {
      if (!this.statistics) return
      const dict = {}
      this.statistics.totalTrafficSource.forEach((item) => {
        if (item.type && !['google', 'facebook', 'qrCode', 'mailfunnel'].includes(item.type)) {
          dict[item.type] = (dict[item.type] || 0) + item.count
        }
      })
      return dict
    },
    directTrafficCount() {
      if (!this.statistics) return
      return this.statistics.totalTrafficSource.reduce((sum, item) => {
        if (!item.type) {
          return sum + item.count
        }
        return sum
      }, 0)
    },
    customTrafficCount() {
      if (!this.statistics) return
      return this.statistics.totalTrafficSource.reduce((sum, item) => {
        if (item.type && !['google', 'facebook', 'qrCode'].includes(item.type)) {
          return sum + item.count
        }
        return sum
      }, 0)
    },
    facebookTrafficCount() {
      if (!this.statistics) return
      const facebook = this.statistics.totalTrafficSource.find((item) => item.type === 'facebook')
      if (facebook) {
        return facebook.count
      }
      return 0
    },
    googleTrafficCount() {
      if (!this.statistics) return
      const google = this.statistics.totalTrafficSource.find((item) => item.type === 'google')
      if (google) {
        return google.count
      }
      return 0
    },
    qrCodeTrafficCount() {
      if (!this.statistics) return
      const qrCode = this.statistics.totalTrafficSource.find((item) => item.type === 'qrCode')
      if (qrCode) {
        return qrCode.count
      }
      return 0
    },
  },
}
</script>
<style scoped>
.no-focus:focus:before {
  background: none;
}
</style>
